// src/features/inventory/pages/BatchDetailPage/tabs/StockLog/index.jsx
import React, { useEffect } from 'react';
import { useStockTransactions } from '../../../../hooks/useStockTransactions';
import { useStockLocations } from '../../../../hooks/useStockLocations';
import StockLogDataGrid from '../../../../components/StockLogDataGrid';

export default function StockLog({ lotId }) {
  const { transactions, loading, error, clearError, fetchTransactionsByLot } = useStockTransactions();
  const { stockLocations, fetchStockLocations } = useStockLocations();

  useEffect(() => {
    fetchTransactionsByLot(lotId);
    fetchStockLocations();
  }, [fetchTransactionsByLot, fetchStockLocations, lotId]);

  return (
    <StockLogDataGrid
      transactions={transactions}
      loading={loading}
      error={error}
      onClearError={clearError}
      showLocationColumn
      locations={stockLocations}
      batchMode
    />
  );
}
